// 年収レンジを変更したために表示も変更するための対応 / 念の為残しておく
// const SALARY_RANGES = [
//   '0 ~ 100万円', '101 ~ 200万円', '201 ~ 250万円', '251 ~ 300万円',
//   '301 ~ 350万円', '351 ~ 400万円', '401 ~ 450万円', '451 ~ 500万円',
//   '501 ~ 600万円', '601 ~ 700万円', '701 ~ 800万円', '801 ~ 900万円',
//   '901 ~ 1000万円', '1001万円以上',
// ];

const SALARY_RANGES = [
  '~ 100万円', '100万円 ~', '200万円 ~', '250万円 ~',
  '300万円 ~', '350万円 ~', '400万円 ~', '450万円 ~',
  '500万円 ~', '600万円 ~', '700万円 ~', '800万円 ~',
  '900万円 ~', '1000万円 ~',
];

export const getSalaryRangeText = (salaryRange: number, fallback = '') => {
  return SALARY_RANGES[salaryRange - 1] || fallback;
};
